document.querySelector(".hero-cta")?.addEventListener("click", (e) => {
  const buy = document.getElementById("buy");
  if (!buy) return;
  e.preventDefault();
  buy.scrollIntoView({ behavior: "smooth", block: "start" });
});

const LABELS = ["Session", "Then After", "Session pair", "After pair"];
const SIZE_GUIDE = { "S/M": "US 5–8.5", "M/L": "US 8–11" };
const LENGTHS = [
  { slug: "ankle", name: "Ankle", copy: "Tab height. One stripe. Color at the heel and toe." },
  { slug: "quarter", name: "Quarter", copy: "Hits above the ankle. One stripe. Color at the heel and toe." },
  { slug: "full", name: "Full", copy: "Crew. One stripe. Color at the heel and toe." },
];
const SWATCH = {
  black: "#1c1a18",
  navy: "#2f4a8a",
  "light-blue": "#8bb8d4",
  red: "#c23b32",
  lilac: "#b59bc7",
  pink: "#c9959a",
  sage: "#8a9a7b",
};
const ORDER = ["black", "navy", "light-blue", "red", "lilac", "pink", "sage"];

function colorKey(handle, title) {
  const h = (handle || "").replace(/^seta-/, "").replace(/-2-pack$/, "");
  if (SWATCH[h]) return h;
  const t = (title || "").toLowerCase().replace(/\s+2-pack$/, "").replace(/\s+/g, "-");
  return SWATCH[t] ? t : h;
}

document.querySelectorAll("[data-card]").forEach((card) => {
  const imgs = [...card.querySelectorAll(".pcard__img")];
  const dots = [...card.querySelectorAll("[data-dot]")];
  const tag = card.querySelector("[data-tag]");
  if (!imgs.length) return;
  let i = 0;
  const show = (n) => {
    i = (n + imgs.length) % imgs.length;
    imgs.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
    dots.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
    if (tag) tag.textContent = LABELS[i] || "";
  };
  card.querySelector("[data-prev]")?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    show(i - 1);
  });
  card.querySelector("[data-next]")?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    show(i + 1);
  });
  dots.forEach((d) =>
    d.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      show(Number(d.dataset.dot));
    }),
  );
});

document.querySelectorAll(".pdp__thumb").forEach((btn) => {
  btn.addEventListener("click", () => {
    const main = document.getElementById("pdp-main");
    if (main && btn.dataset.src) main.src = btn.dataset.src;
    document.querySelectorAll(".pdp__thumb").forEach((b) => b.classList.remove("is-on"));
    btn.classList.add("is-on");
  });
});

(function buyBox() {
  const raw = document.getElementById("seta-catalog");
  if (!raw) return;
  let catalog = [];
  try {
    catalog = JSON.parse(raw.textContent);
  } catch {
    return;
  }
  catalog.forEach((p) => {
    p.key = colorKey(p.handle, p.title);
  });
  catalog.sort((a, b) => {
    const ia = ORDER.indexOf(a.key);
    const ib = ORDER.indexOf(b.key);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  if (!catalog.length) return;

  const main = document.getElementById("buy-main");
  const thumbs = document.getElementById("buy-thumbs");
  const swatches = document.getElementById("buy-swatches");
  const tag = document.getElementById("buy-tag");
  const colorName = document.getElementById("buy-color-name");
  const submit = document.getElementById("buy-submit");
  const guide = document.getElementById("buy-size-guide");
  let color = catalog.find((p) => p.key === "black") || catalog[0];
  let size = "S/M";
  let length = "full";
  let shot = 0;

  function imgSrc(img) {
    return typeof img === "string" ? img : img?.src;
  }
  function imgAlt(img) {
    return (typeof img === "string" ? "" : img?.alt || "").toLowerCase();
  }
  function afterSrc(p, slug) {
    const imgs = p.images || [];
    const hit = imgs.find((img) => {
      const a = imgAlt(img);
      return (
        a.includes("then after") &&
        a.includes(slug) &&
        !a.includes("look") &&
        !a.includes("gym") &&
        !a.includes("combo") &&
        !a.includes("session")
      );
    });
    if (hit) return imgSrc(hit);
    return imgSrc(imgs[3]) || imgSrc(imgs[0]);
  }
  function afterLook(p, slug) {
    const imgs = p.images || [];
    const look = imgs.find((img) => {
      const a = imgAlt(img);
      return a.includes("look") && a.includes("after") && a.includes(slug);
    });
    if (look) return imgSrc(look);
    if (slug === "full") {
      const couple = imgs.find((img) => {
        const a = imgAlt(img);
        return (
          a.includes("then after") &&
          !a.includes("ankle") &&
          !a.includes("quarter") &&
          !a.includes("pair") &&
          !a.includes("full")
        );
      });
      if (couple) return imgSrc(couple);
      return imgSrc(imgs[1]);
    }
    return afterSrc(p, slug);
  }
  function gymLook(p, slug) {
    const imgs = p.images || [];
    const look = imgs.find((img) => {
      const a = imgAlt(img);
      return a.includes("look") && a.includes("gym") && a.includes(slug);
    });
    return look ? imgSrc(look) : "";
  }
  function sessionSrc(p) {
    const imgs = p.images || [];
    const hit = imgs.find((img) => {
      const a = imgAlt(img);
      return a.includes("session") && a.includes("pair");
    });
    return hit ? imgSrc(hit) : imgSrc(imgs[2]);
  }
  function gymSrc(p, slug) {
    const imgs = p.images || [];
    if (slug === "full") return sessionSrc(p);
    const hit = imgs.find((img) => {
      const a = imgAlt(img);
      return a.includes("gym") && a.includes(slug) && !a.includes("look") && !a.includes("combo");
    });
    return hit ? imgSrc(hit) : sessionSrc(p);
  }
  function comboSrc(p, slug) {
    const imgs = p.images || [];
    const hit = imgs.find((img) => {
      const a = imgAlt(img);
      return a.includes("combo") && a.includes(slug);
    });
    return hit ? imgSrc(hit) : "";
  }
  function onfootSrc(p, slug) {
    const imgs = p.images || [];
    const hit = imgs.find((img) => {
      const a = imgAlt(img);
      return a.includes("onfoot") && a.includes(slug);
    });
    return hit ? imgSrc(hit) : "";
  }
  function shotsFor() {
    const lengthName = LENGTHS.find((l) => l.slug === length)?.name || "Full";
    return [
      { src: gymSrc(color, length), label: "Session · " + lengthName },
      { src: afterSrc(color, length), label: "Then After · " + lengthName },
      { src: comboSrc(color, length), label: "2-pack · " + lengthName },
      { src: onfootSrc(color, length), label: "On foot · " + lengthName },
    ].filter((s) => s.src);
  }

  function variant() {
    const lengthName = LENGTHS.find((l) => l.slug === length)?.name || "Full";
    return (
      color.variants.find((v) => {
        const opts = (v.options || []).map(String);
        const title = v.title || "";
        const hasSize = opts.includes(size) || title.includes(size) || v.size === size;
        const hasLen =
          opts.includes(lengthName) ||
          title.toLowerCase().includes(length) ||
          !opts[1];
        return hasSize && hasLen;
      }) ||
      color.variants.find((v) => (v.options || [])[0] === size || v.size === size) ||
      color.variants[0]
    );
  }

  function renderThumbs() {
    if (!thumbs) return;
    const shots = shotsFor();
    thumbs.innerHTML = shots
      .map(
        (s, i) =>
          `<button type="button" class="${i === shot ? "is-on" : ""}" data-shot="${i}"><img src="${s.src}" alt=""></button>`,
      )
      .join("");
    thumbs.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        shot = Number(btn.dataset.shot);
        paint();
      });
    });
  }

  function renderLengths() {
    const el = document.getElementById("buy-lengths");
    if (!el) return;
    el.innerHTML = LENGTHS.map((l) => {
      const src = afterSrc(color, l.slug);
      return `<button type="button" class="length${l.slug === length ? " is-on" : ""}" data-length="${l.slug}"><img src="${src}" alt=""><span>${l.name}</span></button>`;
    }).join("");
    el.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        length = btn.dataset.length;
        shot = 0;
        paint();
      });
    });
  }

  function paint() {
    const shots = shotsFor();
    if (shot >= shots.length) shot = 0;
    if (main && shots[shot]) {
      main.src = shots[shot].src;
      main.style.objectFit = "contain";
    }
    if (tag) tag.textContent = shots[shot]?.label || color.title;
    if (colorName) colorName.textContent = color.title.replace(/\s*2-pack/i, "");
    const lengthMeta = LENGTHS.find((l) => l.slug === length);
    const lengthNameEl = document.getElementById("buy-length-name");
    const lengthCopy = document.getElementById("buy-length-copy");
    if (lengthNameEl) lengthNameEl.textContent = lengthMeta?.name || "Full";
    if (lengthCopy) lengthCopy.textContent = lengthMeta?.copy || "";
    renderThumbs();
    renderLengths();
    document.querySelectorAll("#buy-swatches .buy__swatch").forEach((el) => {
      el.classList.toggle("is-on", el.dataset.key === color.key);
    });
    document.querySelectorAll("#buy-sizes .size").forEach((el) => {
      el.classList.toggle("is-on", el.dataset.size === size);
    });
    if (guide) guide.textContent = SIZE_GUIDE[size] || "";
  }

  if (swatches) {
    swatches.innerHTML = catalog
      .map((p) => {
        const hex = SWATCH[p.key] || "#111";
        return `<button type="button" class="buy__swatch${p.key === color.key ? " is-on" : ""}" data-key="${p.key}" title="${p.title}" style="background:${hex}"></button>`;
      })
      .join("");
    swatches.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        color = catalog.find((p) => p.key === btn.dataset.key) || color;
        shot = 0;
        paint();
      });
    });
  }

  document.querySelectorAll("#buy-sizes .size").forEach((btn) => {
    btn.addEventListener("click", () => {
      size = btn.dataset.size;
      paint();
    });
  });

  document.getElementById("buy-prev")?.addEventListener("click", () => {
    const n = shotsFor().length;
    shot = (shot - 1 + n) % n;
    paint();
  });
  document.getElementById("buy-next")?.addEventListener("click", () => {
    const n = shotsFor().length;
    shot = (shot + 1) % n;
    paint();
  });

  submit?.addEventListener("click", () => {
    const v = variant();
    if (!v?.id) return;
    submit.disabled = true;
    submit.textContent = "Opening checkout…";
    window.location.href = `/cart/${v.id}:1`;
  });

  paint();
})();
